module.exports = __webpack_public_path__ + "img/hanelore-mini.08d3472c.jpg";